import styled from 'styled-components';
import {useEffect, useRef} from "react";

const TweetVideo = styled(({data}) => {

    const iframeRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (iframeRef.current) {
                        if (!entry.isIntersecting) {
                            iframeRef.current.contentWindow.postMessage('pause', '*');
                        }
                    }
                });
            },
            {
                threshold: 0.5,
            }
        );

        if (iframeRef.current) {
            observer.observe(iframeRef.current);
        }

        return () => {
            if (iframeRef.current) {
                observer.unobserve(iframeRef.current);
            }
        };
    }, []);

    return (
        <div style={{position: 'absolute', width: '100%', height: '100%', top: 0, left: 0}} data-vjs-player>
            <iframe allowfullscreen allow="fullscreen" ref={iframeRef} style={{width: "100%", height: "100%", borderRadius: '8px'}} src={`https://player.scored.co?url=${data.video.mpeg ||
            data.video.url}`} />
        </div>
    )
})`
`;

export default TweetVideo;
